import Button from '@brands/Components/Button/Button';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import React, { useCallback } from 'react';

import modalClose from '../../../assets/icons/close.svg';
import Check from '../../../Auth/assets/check.svg';
import styles from './dashboardModal.module.scss';

const SubmitCCConfirmationModal = (): JSX.Element => {
  const roleNavigate = useRoleNavigate();
  const goToDashboard = useCallback(() => {
    roleNavigate('/dashboard');
  }, [roleNavigate]);
  return (
    <div className={styles.modalBackground} onClick={() => goToDashboard()}>
      <div
        className={`fs-unmask ${styles.modalContainer} ${styles.submitConfirmationModal}`}
        onClick={(e) => e.stopPropagation()}
        style={{ width: '50%' }}
      >
        <button
          type="button"
          className={styles.modalClose}
          style={{ backgroundImage: `url(${modalClose})` }}
          aria-label="Close modal"
          onClick={() => goToDashboard()}
        />
        <div className={styles.body}>
          <div className={styles.success}>
            <img src={Check} alt="Success" />
          </div>
          <p className={styles.CCConfirmThankYou}>Thank you!</p>
          <p className={styles.CCConfirmTextContent}>
            To get started, we'll need you to complete a quick form. This helps us understand how best to assist you.
            After we receive your form, we’ll be in touch soon.
          </p>
          <div>
            <Button
              className={`fs-unmask ${styles.CCConfirmButton}`}
              onClick={() => {
                window.open('https://form.jotform.com/251005935350045', '_blank');
              }}
            >
              Complete form
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SubmitCCConfirmationModal;
